<template>
    <span class="a-date date">
        {{ date }}
    </span>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';
import { sv, fi } from 'date-fns/locale';
    
export default {
    name: 'ADate',
    data() {
        return {
            date: '',
            locales: {
                se: sv,
                fi: fi
            }
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale
        })
    },
    mounted() {
        this.getDate();
    },
    methods: {
        getDate () {
            setInterval(() => {
                let day = format(new Date(), 'EEEE', { locale: this.locales[this.locale] });
                day = day.charAt(0).toUpperCase() + day.slice(1)
                let month =  format(new Date(), 'MMMM', { locale: this.locales[this.locale] })
                month = month.charAt(0).toUpperCase() + month.slice(1)
                const numberMonthDay = format(new Date(), 'd', { locale: this.locales[this.locale] })
                const time = format(new Date(), '| HH:mm', { locale: this.locales[this.locale] })
                this.date = day + ' ' + numberMonthDay + ' ' + month + ' ' + time;
            },1000)
        }
    }
}
</script>

<style lang="scss">
@import "a-date";
</style>
